export const MARKETING_URL = 'https://scored.gg';

export const hasTenant = (hostname: string) => {
  const labels = hostname.split('.');

  if (labels.length < 3) {
    return hostname === 'localhost';
  }

  return labels[0] !== 'www';
};

export const leaveForMarketingSite = () => {
  window.location.replace(MARKETING_URL);
};
